/** 轨迹页起终点/停靠点 marker 图标尺寸（与 TransportService 一致需显式 imageSize） */
export const TRACK_ENDPOINT_ICON_W = 28
export const TRACK_ENDPOINT_ICON_H = 48

export function createTrackMarkerIcon(AMap, image, width, height) {
  if (!AMap || !image) return null
  const w = Number(width) || TRACK_ENDPOINT_ICON_W
  const h = Number(height) || TRACK_ENDPOINT_ICON_H
  return new AMap.Icon({
    size: new AMap.Size(w, h),
    image,
    imageSize: new AMap.Size(w, h)
  })
}

/** 缩放结束后重设 icon，避免关联条裁剪/缩放动画后图标尺寸卡住 */
export function reapplyAmapMarkerIcon(marker, icon) {
  if (!marker || !icon || typeof marker.setIcon !== 'function') return
  try {
    marker.setIcon(icon)
  } catch (e) {
    /* ignore */
  }
}

export function refreshTrackOverlayMarkerIcons(host) {
  if (!host) return
  reapplyAmapMarkerIcon(host.markerStart, host.markerStartIcon)
  reapplyAmapMarkerIcon(host.markerEnd, host.markerEndIcon)
  const stopIcon = host.markerStopIcon
  const records = host.parkingMarkerRecords
  if (stopIcon && Array.isArray(records) && records.length) {
    records.forEach(({ marker }) => reapplyAmapMarkerIcon(marker, stopIcon))
    return
  }
  const list = host.markerStopList
  if (!stopIcon || !Array.isArray(list)) return
  list.forEach((item) => reapplyAmapMarkerIcon(item, stopIcon))
}
